module.exports = __webpack_public_path__ + "img/1.1ca57b41.png";